import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import {
    piIconHelpBold,
    piIconUserBold,
    piIconNavigationDownBold,
    piIconChatBubbles,
    piIconClosePanel,
    piIconNavigationMenuBold,
    piIconGear,
    piIconHelp,
    piIconPerson,
    piIconBlackhatLaptop,
    piIconGearBold,
    piIconUnlock,
    piIconSendEmail,
    piIconPattern,
    piIconGraphAnalytics
} from '@predictiveindex/pi-client-icons';
import {
    TapestryIconButtonModule,
    NavMenuListModule,
    PiLogoModule,
    NavOrgLabelModule,
    TapestryIconRegistryService,
    TapestryIconModule,
    TapestryDropdownModule,
    TapestrySidenavModule,
    TapestryTooltipModule,
    TapestryCategoryDropdownComponent
} from '@predictiveindex/tapestry';
import { MyProfileTooltipModule } from '../../my-profile-tooltip';
import { TranslationsModule } from '../../translations';
import { DirectivesModule } from '../Directives';
import { DropdownModule } from '../Dropdown';
import { UpgradeAccountModule } from '../upgrade-account';
import { AccountSelectorComponent } from './account-selector/account-selector.component';
import { AvatarProfileModule } from './avatar-profile/avatar-profile.module';
import { DeveloperDropdownModule } from './developer-dropdown/developer-dropdown.module';
import { SettingsDropdownComponent } from './global-nav-settings/settings-dropdown.component';
import { GlobalNavComponent } from './global-nav.component';
import { GlobalSearchMenuModule } from './global-search-menu/global-search-menu.module';
import { GlobalNavZazzbarComponent } from './global-zazzbar/global-nav-zazzbar.component';
import { LanguageSelectionMenuComponent } from './language-selection-menu/language-selection-menu.component';
import { MobileNavComponent } from './mobile-nav/mobile-nav.component';
import { SellerToolsPeekModule } from './seller-tools/seller-tools.module';
import { TimeTrialBannerClassPipe } from './time-trial/pipes/time-trial-banner-class.pipe';
import { TimeTrialComponent } from './time-trial/time-trial.component';
@NgModule({
    declarations: [
        GlobalNavComponent,
        GlobalNavZazzbarComponent,
        SettingsDropdownComponent,
        AccountSelectorComponent,
        MobileNavComponent,
        TimeTrialComponent,
        TimeTrialBannerClassPipe
    ],
    imports: [
        CommonModule,
        PiLogoModule,
        NavMenuListModule,
        NavOrgLabelModule,
        TapestryDropdownModule,
        TapestryIconButtonModule,
        TapestryIconModule,
        RouterModule,
        DropdownModule,
        ScrollingModule,
        UpgradeAccountModule,
        MatMenuModule,
        MatExpansionModule,
        MyProfileTooltipModule,
        DeveloperDropdownModule,
        TapestryDropdownModule,
        TapestrySidenavModule,
        DirectivesModule,
        GlobalSearchMenuModule,
        AvatarProfileModule,
        TranslationsModule,
        TapestryTooltipModule,
        SellerToolsPeekModule,
        TapestryCategoryDropdownComponent,
        LanguageSelectionMenuComponent
    ],
    exports: [GlobalNavComponent]
})
export class GlobalNavModule {
    constructor(iconRegistry: TapestryIconRegistryService) {
        iconRegistry.registerIcons([
            piIconUserBold,
            piIconHelpBold,
            piIconNavigationDownBold,
            piIconNavigationMenuBold,
            piIconGearBold,
            piIconChatBubbles,
            piIconClosePanel,
            piIconGear,
            piIconHelp,
            piIconPerson,
            piIconBlackhatLaptop,
            piIconUnlock,
            piIconSendEmail,
            piIconPattern,
            piIconGraphAnalytics
        ]);
    }
}
